/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OptimizationType {
    EMPLOYEE_LEAVING = 'employee_leaving',
    SOFTWARE_ACCOUNT_DUPLICATE = 'software_account_duplicate',
    SOFTWARE_ACCOUNT_REDUNDANT_LICENSES = 'software_account_redundant_licenses',
    SOFTWARE_ACCOUNT_UNUSED = 'software_account_unused',
    SOFTWARE_ACCOUNT_RIGHTSIZING = 'software_account_rightsizing',
}
